import { NgbDate, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { BillingService } from './../../../services/billing.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import {debounceTime, distinctUntilChanged, first, map} from 'rxjs/operators';
import * as jquery from 'jquery';
import {fromEvent} from "rxjs";

@Component({
  selector: 'app-billing-history',
  templateUrl: './billing-history.component.html',
  styleUrls: ['./billing-history.component.scss'],
})

export class BillingHistoryComponent implements OnInit, AfterViewInit {

  p: any;
  billings = [];
  search_name = '';
  processingSearch = 0;

  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  fromDateYmd: string;
  toDateYmd: string;
  dpFromDate: NgbDate;
  dpToDate: NgbDate;

  currentPage: number;
  lastPage: number;
  pageLinks: number[] = [];
  searchValue = '';
  error = false;
  modalText = 'Loading...';
  loading = true;

  readonly DELIMITER = '-';

  constructor(
    private pageTitleService: Title,
    private route: ActivatedRoute,
    private billingService: BillingService,
    private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter
  ) {
    // this.fromDate = calendar.getToday();
    // this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);
  }

  ngOnInit(): void {
    this.setPageTitle();
    this.showProgressModal();
    this.loadBilling();
  }

  ngAfterViewInit(): void {
    this.search();
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Billing History');
  }

  onDateFromSelection(fromDate: NgbDate) {
    this.fromDate = fromDate;
    const fromDateF = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    if (this.toDate) {
      if (this.fromDate.after(this.toDate)) {
        jquery('#dateInputFrom').val(fromDateF);
        this.fromDate = fromDate;

        this.toDate = null;
        this.dpToDate = null;
      } else {
        jquery('#dateInputFrom').val(fromDateF);
      }
    }
    this.onDateSelection();
  }

  onDateToSelection(toDate: NgbDate) {
    this.toDate = toDate;
    const toDateF = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
    if (this.fromDate) {
      if (this.toDate.before(this.fromDate)) {
        jquery('#dateInputFrom').val(toDateF);
        this.fromDate = toDate;

        jquery('#dateInputTo').val('');
        this.toDate = null;
        this.dpToDate = null;
      } else {
        jquery('#dateInputTo').val(toDateF);
      }
    }
    this.onDateSelection();
  }

  onDateSelection() {

    this.fromDateYmd = '';
    if (this.fromDate) {
      this.fromDateYmd = this.fromDate.year + '-' + this.fromDate.month + '-' + this.fromDate.day;
    }

    this.toDateYmd = '';
    if (this.toDate) {
      this.toDateYmd = this.toDate.year + '-' + this.toDate.month + '-' + this.toDate.day;
    }

    this.modalText = 'Searching...';
    this.loadBilling(1, this.search_name, this.fromDateYmd, this.toDateYmd);
  }

  clearDateFrom() {
    if (this.fromDate) {
      jquery('#dateInputFrom').val('');
      this.fromDateYmd = '';
      this.dpFromDate = null;
      this.loadBilling(1, this.search_name, this.fromDateYmd, this.toDateYmd);
    }
  }

  clearDateTo() {
    if (this.toDate) {
      jquery('#dateInputTo').val('');
      this.toDateYmd = '';
      this.dpToDate = null;
      this.loadBilling(1, this.search_name, this.fromDateYmd, this.toDateYmd);
    }
  }

  search() {
    // this.search_name = event.target.value;
    // this.modalText = 'Searching...';
    // this.loadBilling(1, this.search_name);

    const searchBox = document.getElementById('searchBillingInput');
    const keyup$ = fromEvent(searchBox, 'keyup');
    keyup$
      .pipe(
        map((event: any) => {
          this.search_name = event.target.value;
          return event.target.value;
        }),
        debounceTime(2000),
        distinctUntilChanged()
      )
      .subscribe((text: string) => {
        this.modalText = (text !== '') ? 'Searching...' : 'Loading...';
        this.loadBilling(1, this.search_name);
      });

  }

  loadBilling(pageNumber: number = 1, searchValue: string = '', fromDateYmd: string = '', toDateYmd: string = '') {
      this.billings = [];
      this.processingSearch = 1;

      // Show progress modal
      this.showProgressModal();

      this.billingService.getAdminBillingHistory(pageNumber, searchValue, fromDateYmd, toDateYmd)
        .pipe(first())
        .subscribe(
          data => {
            jquery('.close').click();
            // console.log(data);
            this.billings = data.data.billing;
            const totalRecords = data.data.pagination?.total_records;
            this.lastPage = data.data.pagination?.last_page;
            this.pageLinks = [];
            if (totalRecords > 0) {
              this.currentPage = data.data.pagination?.current_page;
              for (let index = 1; index <= this.lastPage; index++) {
                this.pageLinks.push(index);
              }
            }
            this.processingSearch = 0;

            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
              this.loading = false;
            }, 500);

          },
          error => {
            // hide progress modal
            this.hideProgressModal();
            this.error = true;
          }
        );
  }

  paginate(pageNumber: number) {
    if (pageNumber > 0) {
      this.loadBilling(pageNumber, this.searchValue);
    }
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
